import { render, staticRenderFns } from "./HomeTags.vue?vue&type=template&id=19e45e2a&scoped=true"
import script from "./HomeTags.vue?vue&type=script&lang=js"
export * from "./HomeTags.vue?vue&type=script&lang=js"
import style0 from "./HomeTags.vue?vue&type=style&index=0&id=19e45e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e45e2a",
  null
  
)

export default component.exports